import Head from "next/head";
import { useRouter } from "next/router";
import CryptoConverter from "../../../components/CryptoConverter";

const CryptoConverterPage = () => {
  const router = useRouter();
  const queryString = router?.asPath?.split("?")?.[1]; //the widget query parameters to pass down

  return (
    <>
      <Head>
        <title>Crypto Converter | WazirX</title>
        <meta name="description" content="Comparision on Crypto Converter" />
      </Head>

      <CryptoConverter query={queryString} />
    </>
  );
};

export default CryptoConverterPage;
